import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyD41209vIyUbSJhcweWKCwnaCwW87hToYk',
  authDomain: 'YOUR_AUTH_DOMAIN',
  projectId: 'dailo-7811c',
  storageBucket: 'gs://dailo-7811c.appspot.com/',
  messagingSenderId: '183091390121',
  appId: '1:183091390121:android:c239654ba583484377ebb8',
};
const firebaseApp = initializeApp(firebaseConfig);
const database = getDatabase(firebaseApp);

export { database };